"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
var Arrayify = function Arrayify(value) {
	if (!Array.isArray(value)) {
		return [value];
	}

	return value;
};

exports.default = Arrayify;


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/common/Arrayify/index.js